import React, { useState, useEffect, useContext } from "react";
import { Card, Form } from "react-bootstrap";
import Heading from "../../Components/Heading/Heading";
import SelectForm from "../../Components/SelectForm/SelectForm";
import InputForm from "../../Components/InputForm/InputForm";
import "react-datepicker/dist/react-datepicker.css";
import "./TaskAssignment.css";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { APICall } from "../../Helpers/API/APICalls";
import { useLocation, useNavigate } from "react-router-dom";
import "../../Pages/TaskAssignment/TaskAssignment.css";
//added by kausher
import { APICalls } from "../../Helpers/API/APICalls2";
import axios from "axios";
//ended by kausher

import uuid from "react-uuid";
import {
  getAutoPopulateRequirementHrs,
  getAutoPopulateRequirementTiltleDropdown,
  getAutoPopulatedAssignedHoursData,
  getAutoPopulatedDataForTask,
  getCapacityAllocationDataByEngagement,
  GetDropDownList,
  InsertUpdateTask,
  insertTaskHistory,
  EditTaskRecord,
  mailForIsUnplannedPlannedTask,
  checkForEngagementLead,
  checkForCapacityallocation,
} from "../../Helpers/API/APIEndPoints";
import { useParams } from "react-router-dom";
import { ApplicationContext } from "../../Routes/Routes";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import { TaskStatus } from "../../Common/CommonJson";

import moment from "moment";
import notify from "../../Helpers/ToastNotification";
import { id } from "date-fns/locale";
import { GetIsUnplannedReasonsList } from "../../Helpers/API/APIEndPoints";

import { Modal } from "react-bootstrap";

function TaskAssignment() {
  let navigate = useNavigate();
  const { EmployeeId, RoleId } = getContext();
  //const { RoleId,EmployeeId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const location = useLocation();
  const [disabled, setDisabled] = useState(false);
  const [Engagement, setEngagement] = useState<any>({});
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [EngagementType, setEngagementType] = useState<any>(null);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [fromDate, setFromDate] = React.useState<any>(null);
  const [toDate, setToDate] = React.useState<any>(null);

  const [Task, setTask] = useState<any>("");
  const [Description, setDescription] = useState<any>("");
  const [AssignedTo, setAssignedTo] = useState<any>({});
  const [AssignedToOptions, setAssignedToOptions] = useState<any>([]);

  const [Startbydate, setStartbydate] = React.useState<Date | null>(new Date());
  const [Completebydate, setCompletebydate] = React.useState<Date | null>(
    new Date()
  );
  const [PlannedHours, setPlannedHours] = useState<any>("");
  const [isChargable, setisChargable] = useState<any>(true);
  const [Reason, setReason] = useState<any>({});
  const [IsUnPlannedReason, setIsUnplannedReason] = useState<any>({});

  const [ReasonOptions, setReasonOptions] = useState<any>([]);
  const [budgetMandaysPerMonth, setBudgetMandaysPerMonth] = useState<any>("");
  const [allocatedMandays, setAllocatedMandays] = useState<any>("");
  const [assignedMandays, setAssignedMandays] = useState<any>("");
  const [balancedMandays, setBalancedMandays] = useState<any>("");
  const [allocatedHours, setAllocatedHours] = useState<any>("");
  const [assignedHours, setAssignedHours] = useState<any>("");
  const [isAdhoc, setIsAdHoc] = useState<boolean>(false);
  const context = getContext();

  const [Requirement, setRequirement] = useState<any>("");
  const [RequirementOptions, setRequirementOptions] = useState<any>([]);
  const [EstimatedHrsWO, setEstimatedHrsWO] = useState<any>("");
  const [EstimatedHrs, setEstimatedHrs] = useState<any>("");
  const [BalanceHrs, setBalanceHrs] = useState<any>("");
  const [RequirementID, setRequirementID] = useState<any>("");
  const [dropDown1, setDropDown1] = useState(false);
  //const [RequirementId, setRequirementId] = useState<any>({}); //Pass this requirement Id to autopopulate Requirement Hrs
  const [assignedToOptionsLoaded, setAssignedToOptionsLoaded] = useState(false);
  const [formErrors, setFormErrors] = useState<any>({});
  const [isActive, setIsActive] = useState(false);
  const [selectedIsUnplannedReason, setSelectedIsUnplannedReason] =
    useState<any>({});
  const [isPlanned, setIsPlanned] = useState(false); //prashant
  const [unplannedbyid, setUnplannedbyid] = useState(null); //prashant
  const [isEngagementLead, setIsEngagementLead] = useState(false); //Prashant
  const [isCapacityallocated, setIsCapacityallocated] = useState(0); //Prashant
  // const [foundEngTyp, setFoundEngTyp] = useState(null);
  let formErrorObj = {};
  var reasons;

  //added by kausher
  const [sharePointLink, setSharePointLink] = useState(null);
  const [taskId, setTaskId] = useState(0);
  const [engagementName, setEngagementName] = useState(null);
  const [taskCreatedDate, setTaskCreatedDate] = useState(null);
  // const [FileNames, setFileNames] = useState<string[]>([]);
  const [FileNames, setFileNames] = useState<string[]>([`No attachments`]);

  const [files, setFiles] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");

  const handleFiles = (
    e: React.ChangeEvent<HTMLInputElement>,
    apiFieldName: string
  ) => {
    const selectedFiles = e.target.files;

    if (!selectedFiles || selectedFiles.length === 0) {
      setFormErrors((prevState) => ({
        ...prevState,
        ["File_isEmpty"]: "Please upload file",
      }));
      return;
    } else {
      setFormErrors((prevState) => ({
        ...prevState,
        ["File_isEmpty"]: undefined,
      }));
    }

    // Allowed file types
    const allowedTypes = new Set([
      "application/pdf", // PDF
      "application/msword", // DOC
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "image/png", // PNG
      "image/jpeg", // JPEG, JPG
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-powerpoint", // PPT
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PPTX
      "message/rfc822", // EML
    ]);

    const validFiles: File[] = [];
    const invalidFiles: File[] = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      if (allowedTypes.has(file.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file);
      }
    }
    
    
    if (validFiles.length > 0) {
      setFileNames([`${validFiles.length} files selected`]);
      setFiles(validFiles);

      setErrorMsg("");
    }

    if (validFiles.length <= 5) {
      //notify(1, "At Max five Files are allowed");
      setFormErrors((prevState) => ({
        ...prevState,
        ["AtMaxFiveFiles"]: "",
      }));
    
    }

    // Handle invalid files
    if (invalidFiles.length > 0) {
      notify(
        1,
        "The selected files are not allowed. Please upload valid files."
      );
      setErrorMsg(
        "The selected files are not allowed. Please upload valid files."
      );
    }
  };

  //ended by kausher

  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );
  let EditId;
  EditId = (location.state as { id: number })?.id;
  // const EditId = (location.state as { id: number })?.id;
  const EditStatus = (location.state as { status: string })?.status; //Prashant

  //Prashant
  // const checkEngagementLead =async()=>{

  //   let obj ={
  //     CreatedBy : EmployeeId,
  //     EngagementId: Engagement.engagementId,

  //   }

  //Pinky Add for engagementlead
  const checkEngagementLead = async () => {
    let obj = {
      EngagementId: Engagement.engagementId,
      EmployeeId: EmployeeId,
      fromDate: moment(Startbydate).format(moment.HTML5_FMT.DATE),
      toDate: moment(Completebydate).format(moment.HTML5_FMT.DATE),
    };

    const { data } = await APICall(checkForEngagementLead, "POST", obj);

    if (data != null || data != undefined) {
      setIsEngagementLead(data[0]?.isEngagementLead);
    }
  };
  const checkCapacityAllocation = async () => {
    showLoader();
    let obj = {
      EngagementId: Engagement.engagementId,
      EmployeeId: EmployeeId,
      fromDate: moment(Startbydate).format(moment.HTML5_FMT.DATE),
      // toDate: moment(Completebydate).format(moment.HTML5_FMT.DATE),
    };

    const { data } = await APICall(checkForCapacityallocation, "POST", obj);

    if (data != null || data !== undefined) {
      if (data[0]?.id != 0) {
        setIsCapacityallocated(1);
        hideLoader();
      } else {
        setIsCapacityallocated(0);
        hideLoader();
      }
    }
    hideLoader();
  };

  useEffect(() => {
    if (Engagement && Object.keys(Engagement)?.length > 0) {
      (async () => {
        await checkEngagementLead();
        await checkCapacityAllocation();
      })();
    }
  }, [Engagement, Startbydate]);

  useEffect(() => {
    (async () => {
      const { data } = await APICall(GetIsUnplannedReasonsList, "POST", {});

      if (isPlanned != undefined || isPlanned != null) {
        let tempArrays = data?.map((reasons) => ({
          value: reasons.id,
          label: reasons.unplannedReason,
        }));
        setIsUnplannedReason(tempArrays);
      }
    })();
  }, []);

  //prashant
  useEffect(() => {
    const checkisPlannedorUnplanned = async () => {
      //commented by mahesh , to show amc and all eng
      // if (EngagementType == 2 || EngagementType == 3) {
      //   await setIsPlanned(false);
      // } else {
      //   await setIsPlanned(true);
      // }
      await setIsPlanned(false);
    };
    checkisPlannedorUnplanned();
  }, [EngagementType]);

  //Omkar P
  useEffect(() => {
    if (dropDown1) {
      getUserId();
    }
  }, [EngagementOptions, assignedToOptionsLoaded, AssignedToOptions]);

  //get managerDahboared id
  const getUserId = async () => {
    showLoader();
    let tempArray = [];
    if (location.state !== null) {
      const GetEditTaskResp = await APICall(EditTaskRecord, "POST", {
        Id: EditId,
      });

      const TaskRecord = GetEditTaskResp.data;

      // if (TaskRecord == null) {
      //   notify(1, "This Task is not active");
      //  }
      //   else {
      //Engagement Label set

      //added by kausher
      if (TaskRecord.sharepointLink !== null) {
        setSharePointLink(TaskRecord.sharepointLink);
      }
      if (TaskRecord.engagementName !== null) {
        setEngagementName(TaskRecord.engagementName);
      }
      if (TaskRecord.engagementID > 0) {
        setTaskId(TaskRecord.id);
      }
      if (TaskRecord.createdDate !== null) {
        setTaskCreatedDate(TaskRecord.createdDate);
      }

      //ended by kausher
      const EngId = TaskRecord && TaskRecord.engagementID;

      const foundEngagement = EngagementOptions.find(
        (item) => item.engagementId == EngId
      );

      if (foundEngagement) {
        setEngagement(foundEngagement);

        // setFoundEngTyp(foundEngagement.engagementType);
      } else {
        console.error(`check this ${EngId} not found in Engagement dropdown.`);
      }

      //Is chargable
      setisChargable(TaskRecord.isChargeable);

      //select Reason
      const reason = await CommonDropdownFunction(
        "reason",
        foundEngagement.engagementType, // Assuming engagementType is the key
        true
      );

      if (reason != undefined || reason != null) {
        tempArray = reason.map((reasons) => ({
          value: reasons.id,
          label: reasons.reason,
        }));
        setReasonOptions(tempArray);
        const reasonId = TaskRecord.noChargesReason;
        const foundReason = tempArray.find((item) => item.label == reasonId);
        // if (foundReason) {
        setReason(foundReason);
        // }
      }

      //prashant
      const foundEngagementtype = EngagementOptions.find(
        (item) => item.engagementId == EngId
      );
      //commented by mahesh ,due to reason and is planned are not comming correctly
      // if (
      //   foundEngagementtype.engagementType == 2 ||
      //   foundEngagementtype.engagementType == 3
      // ) {
      setEngagementType(foundEngagementtype.engagementType);
      setIsPlanned(TaskRecord.isUnplanned);
      const foundReason = IsUnPlannedReason.find(
        (item) => item.value == TaskRecord.unplannedReasons
      );
      setSelectedIsUnplannedReason(foundReason);
      // }
      //end

      //prashant

      // Assign to label set
      const assignId = TaskRecord.assignedTo;
      // setAssValue(TaskRecord.assignedTo);
      let assignedToArray = [];
      if (!assignedToOptionsLoaded) {
        assignedToArray = await assignedToApiCall(EngId, TaskRecord.assignedTo);
      }
      const foundAssign = AssignedToOptions.find(
        (item) => item.value == assignId
      );
      if (foundAssign) {
        setAssignedTo(foundAssign);
      } else {
        console.error(`Check this ${assignId} not found in assignedToOptions.`);
      }

      // Task title
      setTask(TaskRecord.taskTitle);
      // Task Description
      setDescription(TaskRecord.taskDescription);

      setPlannedHours(TaskRecord.hoursAssigned);
      // setAssignedHours(TaskRecord.hoursAssigned);

      //Requirement Title
      const requireTtl = TaskRecord.title;
      const requirementTitleData = await getRequirementTitle(EngId);
      if (requirementTitleData) {
        let tempArray = [];
        requirementTitleData.forEach((requirementTitle) => {
          let tempObj = {
            value: requirementTitle.id,
            label: requirementTitle.title,
          };
          tempArray.push(tempObj);
        });
        setRequirementOptions(tempArray);
        const foundReq = tempArray.find((item) => item.label == requireTtl);
        if (foundReq) {
          setRequirement(foundReq);
        }
      }
      // Requirement Id
      setRequirementID(TaskRecord.requirementID);
      setBalanceHrs(TaskRecord.balance);

      setStartbydate(TaskRecord.plannedStartDate);
      setCompletebydate(TaskRecord.plannedEndDate);
      // const requirementData = await getautoPopulateRequirementHrs(
      //   TaskRecord.requirementEngagementID
      // );
      // if (requirementData) {
      //   setBalanceHrs(requirementData.balance);
      // } else {
      //   null;
      // }
      setEstimatedHrsWO(TaskRecord.estimat_Hours_w_o);
      setEstimatedHrs(TaskRecord.estimate_Hours);
      setIsActive(TaskRecord.isActive);
      await handleTextEvent(TaskRecord.requirementEngagementID, "BalanceHrs");
      setDropDown1(false);
      // }
    }

    hideLoader();
  };
  // Omkar p

  const assignedToApiCall = async (engagementId: any, assValue: any) => {
    showLoader();
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    let postObject = {
      searchFor: "assignedTo",
      searchValue: engagementId,
      fromDate: moment(firstDay).format(moment.HTML5_FMT.DATE),
      toDate: moment(lastDay).format(moment.HTML5_FMT.DATE),
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);
    let assignedToArray = [];
    if (data != undefined || data != null) {
      assignedToArray = data.map((assignedTo: any) => ({
        eid: assignedTo.id,
        value: assignedTo.id,
        label: assignedTo.name,
      }));
      assignedToArray.sort((a, b) => a.label.localeCompare(b.label));
      setAssignedToOptions(assignedToArray);
      setDropDown1(true);
      setAssignedToOptionsLoaded(true);
    }
    hideLoader();
    var postObj = {
      EngagementId: engagementId,
      EmployeeId: assValue,
      fromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
      toDate: moment(toDate).format(moment.HTML5_FMT.DATE),
    };
    var autoPopulateData = await APICall(
      getAutoPopulatedAssignedHoursData,
      "POST",
      postObj
    );
    if (autoPopulateData.data != undefined || autoPopulateData.data != null) {
      setAllocatedHours(
        autoPopulateData.data.hoursAllocated
          ? autoPopulateData.data.hoursAllocated * 8.5
          : 0
      );
      setAssignedHours(
        autoPopulateData.data.hoursAssigned
          ? autoPopulateData.data.hoursAssigned
          : 0
      );
    }
    await setFormErrors({
      ...formErrors,
      ["AssignedTo_isEmpty"]: "",
    });

    // Return assignedToArray from the function
    return assignedToArray;
  };
  // omkar p

  const getAutoPopulateData = async () => {
    showLoader();
    if (
      Engagement.engagementId !== null &&
      fromDate !== null &&
      toDate !== null
    ) {
      var postObj = {
        EngagementId: Engagement.engagementId,
        fromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        toDate: moment(toDate).format(moment.HTML5_FMT.DATE),
      };

      var autoPopulateData = await APICall(
        getAutoPopulatedDataForTask,
        "POST",
        postObj
      );

      if (autoPopulateData.data != undefined || autoPopulateData.data != null) {
        setFormErrors({
          ...formErrors,
          ["fromDate_isEmpty"]: "",
        });

        setFormErrors({
          ...formErrors,
          ["toDate_isEmpty"]: "",
        });

        if (autoPopulateData.data.mandays == null) {
          autoPopulateData.data.mandays = 0;
        }
        setAllocatedMandays(autoPopulateData.data.mandays);
        setAssignedMandays(
          (autoPopulateData.data.hoursAssigned / 8.5).toFixed(2)
        );
        setBalancedMandays(
          (
            autoPopulateData.data.mandays -
            autoPopulateData.data.hoursAssigned / 8.5
          ).toFixed(2)
        );
      } else {
        //  setFromDate(null);
        // setToDate(null);
        setAllocatedMandays("");
        setAssignedMandays("");
        setBalancedMandays("");
        setAllocatedHours("");
        setAssignedHours("");
      }
    }
    // else {
    //   if (fromDate == undefined || fromDate == null || fromDate == "") {
    //     await setFormErrors({
    //       ...formErrors,
    //       ["fromDate_isEmpty"]: "from date cannot be empty",
    //     });
    //   }
    //   if (toDate == undefined || toDate == null || toDate == "") {
    //     await setFormErrors({
    //       ...formErrors,
    //       ["toDate_isEmpty"]: "To date cannot be empty",
    //     });
    //   }
    // }
    hideLoader();
  };

  const getBudgetMandays = async (id, type) => {
    const eType =
      type === 1
        ? "AMC"
        : type === 2
        ? " PRODUCT"
        : type === 3
        ? "PROJECT"
        : type === 4
        ? "T&M"
        : "INTERNAL";

    let post = {
      EngagementId: id,
      EngagementType: eType,
    };
    const { data } = await APICall(
      getCapacityAllocationDataByEngagement,
      "POST",
      post
    );
    // if (data && data.budgetMandaysPerMonth !== null) {
    //   setBudgetMandaysPerMonth(data.budgetMandaysPerMonth);
    // } else {
    //   setBudgetMandaysPerMonth("0");}
  };

  const getautoPopulateRequirementHrs = async (id) => {
    showLoader();
    let post = {
      RequirementID: id,
    };
    const data = await APICall(getAutoPopulateRequirementHrs, "POST", post);

    setDropDown1(true);
    hideLoader();
    return data;
  };

  const getRequirementTitle = async (id) => {
    showLoader();
    var PostObj = {
      EngagementID: id,
    };
    const { data } = await APICall(
      getAutoPopulateRequirementTiltleDropdown,
      "POST",
      PostObj
    );
    hideLoader();
    return data;
  };

  useEffect(() => {
    getAutoPopulateData();
  }, [fromDate, toDate, Engagement]);

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    //debugger;
    if (!isAdhoc) {
      if (apiFieldName === "fromDate") {
        let date = event;
        await setFromDate(date);
        //    await  getAutoPopulateData();
        await setFormErrors({
          ...formErrors,
          ["fromDate_isEmpty"]: "",
        });

        if (event == undefined || event == null || event == "") {
          await setFormErrors({
            ...formErrors,
            ["fromDate_isEmpty"]: "From date cannot be empty",
          });
        }
      }
      if (apiFieldName === "toDate") {
        let date = event;
        await setToDate(date);
        //await getAutoPopulateData();
        await setFormErrors({
          ...formErrors,
          ["toDate_isEmpty"]: "",
        });

        if (event == undefined || event == null || event == "") {
          await setFormErrors({
            ...formErrors,
            ["toDate_isEmpty"]: "To date cannot be empty",
          });
        }
      }
    }
    if (apiFieldName === "TaskDescription") {
      setDescription(event.target.value);
      await setFormErrors({
        ...formErrors,
        ["TaskDescription_isEmpty"]: "",
      });

      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        await setFormErrors({
          ...formErrors,
          ["TaskDescription_isEmpty"]: "Task description cannot be empty",
        });
      }
    }
    if (apiFieldName === "PlannedHours") {
      setPlannedHours(event.target.value);
      await setFormErrors({
        ...formErrors,
        ["PlannedHours_isEmpty"]: "",
      });

      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        await setFormErrors({
          ...formErrors,
          ["PlannedHours_isEmpty"]: "Planned Hours cannot be empty",
        });
      }
    }
    if (apiFieldName === "TaskTitle") {
      setTask(event.target.value);
      await setFormErrors({
        ...formErrors,
        ["TaskTitle_isEmpty"]: "",
      });

      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        await setFormErrors({
          ...formErrors,
          ["TaskTitle_isEmpty"]: "Task Title cannot be empty",
        });
      }
    }
    if (apiFieldName === "Startbydate") {
      setStartbydate(event);
      await setFormErrors({
        ...formErrors,
        ["Startbydate_isEmpty"]: "",
      });

      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["Startbydate_isEmpty"]: "Start By date cannot be empty",
        });
      }
    }
    if (apiFieldName === "Completebydate") {
      setCompletebydate(event);
      await setFormErrors({
        ...formErrors,
        ["Completebydate_isEmpty"]: "",
      });

      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["Completebydate_isEmpty"]: "Complete By date cannot be empty",
        });
      }
    }
    if (apiFieldName === "TaskDescription") {
      setDescription(event.target.value);
      await setFormErrors({
        ...formErrors,
        ["TaskDescription_isEmpty"]: "",
      });

      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        await setFormErrors({
          ...formErrors,
          ["TaskDescription_isEmpty"]: "Task description cannot be empty",
        });
      }
    }
    if (apiFieldName === "allocatedMandays") {
      setAllocatedMandays(event.target?.value);
    }
    if (apiFieldName === "assignedMandays") {
      setAssignedMandays(event.target?.value);
    }
    if (apiFieldName === "balancedMandays") {
      setBalancedMandays(event.target?.value);
    }
    if (apiFieldName === "allocatedHours") {
      setAllocatedHours(event.target?.value);
    }
    if (apiFieldName === "assignedHours") {
      setAssignedHours(event.target?.value);
    }
    if (apiFieldName === "RequirementId") {
      RequirementID(event.target?.value);
    }
    if (apiFieldName === "BalanceHrs") {
      setBalanceHrs(event.target?.value);
    }
    if (apiFieldName === "EstimateHrsWo") {
      setEstimatedHrsWO(event.target?.value);
    }
    if (apiFieldName === "EstimateHrs") {
      setEstimatedHrs(event.target?.value);
    }
  };

  const handleCheckEvent = async (checkedValue, apiFieldName) => {
    if (apiFieldName === "IsChargable") {
      await setFormErrors({
        ...formErrors,
        ["Reason_isEmpty"]: "",
      });
      let checkVal = checkedValue;
      await setisChargable(checkVal);
      setReason("Select");
    }
  };

  const checkValidations = async () => {
    var objError = {};
    if (
      Engagement.engagementId == undefined ||
      Engagement.engagementId == null ||
      Engagement.engagementId == ""
    ) {
      objError["engagement_isEmpty"] = "Select Engagement";
    }

    if (!isAdhoc) {
      if (fromDate == undefined || fromDate == null || fromDate == "") {
        objError["fromDate_isEmpty"] = "From date cannot be empty";
      }

      if (toDate == undefined || toDate == null || toDate == "") {
        objError["toDate_isEmpty"] = "To date cannot be empty";
      }

      if (
        AssignedTo.value == undefined ||
        AssignedTo.value == null ||
        AssignedTo.value == ""
      ) {
        objError["AssignedTo_isEmpty"] = "Assigned To cannot be empty";
      }
      if (Engagement.engagementType === 3 || RequirementOptions.length > 0) {
        if (
          Requirement.value == undefined ||
          Requirement.value == null ||
          Requirement.value == ""
        ) {
          objError["Requirement_isEmpty"] = "Select Requirement";
        }
      }
    }

    if (Task == undefined || Task == null || Task == "") {
      objError["TaskTitle_isEmpty"] = "Task Title cannot be empty";
    }

    if (Description == undefined || Description == null || Description == "") {
      objError["TaskDescription_isEmpty"] = "Task Description cannot be empty";
    }

    if (Startbydate == undefined || Startbydate == null) {
      objError["Startbydate_isEmpty"] = "Start by date cannot be empty";
    }

    if (Completebydate === undefined || Completebydate === null) {
      objError["Completebydate_isEmpty"] = "Complete by date cannot be empty";
    }
    if (
      PlannedHours === undefined ||
      PlannedHours === null ||
      PlannedHours === "" ||
      isNaN(PlannedHours) ||
      PlannedHours <= 0
    ) {
      objError["PlannedHours_isEmpty"] = "Planned Hours cannot be empty";
    }
    //prashant

    if (
      !isPlanned &&
      (selectedIsUnplannedReason.value === null ||
        selectedIsUnplannedReason.value === undefined ||
        selectedIsUnplannedReason.value === "")
    ) {
      objError["IsUnplannedReason_isEmpty"] =
        "IsUnplannedReason cannot be empty";
    }
    if (Engagement.engagementType === 3 || RequirementOptions.length > 0) {
      if (
        Requirement.value == undefined ||
        Requirement.value == null ||
        Requirement.value == ""
      ) {
        objError["Requirement_isEmpty"] = "Select Requirement";
      }
    }
    if (RequirementOptions.length > 0) {
      if (
        isChargable == false &&
        (Reason.value === undefined ||
          Reason.value === null ||
          Reason.value === "")
      ) {
        objError["Reason_isEmpty"] = "Reason cannot be empty";
      }
    }
    if (files.length > 5) {
      objError["AtMaxFiveFiles"] = "At max five files are allowed";
    }
     else {
      if (
        isChargable == false &&
        (Reason.value === undefined ||
          Reason.value === null ||
          Reason.value === "")
      ) {
        objError["Reason_isEmpty"] = "Reason cannot be empty";
      }
    }

    

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      if (isAdhoc) {
        if (
          Engagement.engagementType === 2 ||
          Engagement.engagementType === 3
        ) {
          if (
            (RoleId.includes("3") || RoleId.includes("8")) &&
            isCapacityallocated === 0
          ) {
            notify(
              1,
              "You're not allowed to create a Task for this Engagement. You need to be allocated for this engagement."
            );
          }
          // Check if RoleId includes 2 or 3 and isEngagementLead is false
          else if (
            (RoleId.includes("2") || RoleId.includes("1")) &&
            isEngagementLead === false &&
            !RoleId.includes("8") &&
            !RoleId.includes("3")
          ) {
            //
            notify(
              1,
              "You're not allowed to create a Task for this Engagement. You need to be the engagement lead for this engagement."
            );
          } else {
            await checkValidations();

            const isEmpty = await Object.values(formErrorObj).every(
              (x) => x === null || x === "" || x == undefined
            );

            if (isEmpty) {
              showLoader();
              let requestObject = {};
              requestObject = {
                TaskUid: uuid(),
                Id: EditId,
                TaskTitle: Task,
                EngagementId: Engagement.engagementId,
                PhaseId: parseInt(Engagement.phasevalue),
                ApplicationId: parseInt(Engagement.applicationValue),
                RequirementId: Requirement.value, //Ankita
                TaskDescription: Description,
                AssignedTo: isAdhoc ? context.EmployeeId : AssignedTo.value,
                PlannedStartDate: moment(Startbydate).format(
                  moment.HTML5_FMT.DATE
                ),
                PlannedEndDate: moment(Completebydate).format(
                  moment.HTML5_FMT.DATE
                ),
                HoursAssigned: Number(PlannedHours).toFixed(2),
                HoursSpent: 0,
                TaskStatus:
                  EditStatus === "In Progress" ? 3 : TaskStatus.NotStarted, //prashant 3 = in progress
                IsChargeable: isChargable,
                CreatedBy: context.EmployeeId,
                CreatedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
                NoChargesReason: isChargable
                  ? ""
                  : Reason.label
                  ? Reason.label
                  : "",
                IsUnplanned: isPlanned,
                IsActive: isActive,
                UnplannedReasons: isPlanned
                  ? null
                  : selectedIsUnplannedReason.value,
                //UnplannedReasons : selectedIsUnplannedReason.value? selectedIsUnplannedReason.value :null,
                // IsUnplannedReasonId:selectedIsUnplannedReason && selectedIsUnplannedReason.value,
              };

              let formData = new FormData();

              formData.append("TaskUid", uuid());
              const idValue = EditId ?? 0;
              formData.append("Id", idValue.toString());
              formData.append("TaskTitle", Task);
              formData.append(
                "EngagementId",
                Engagement.engagementId
                  ? Engagement.engagementId.toString()
                  : "0"
              );
              formData.append(
                "PhaseId",
                Engagement.phasevalue ? Engagement.phasevalue : ""
              );
              formData.append(
                "ApplicationId",
                Engagement.applicationValue ? Engagement.applicationValue : ""
              );
              formData.append(
                "RequirementId",
                Requirement.value ? Requirement.value.toString() : ""
              );
              formData.append("TaskDescription", Description);
              formData.append(
                "AssignedTo",
                (isAdhoc ? context.EmployeeId : AssignedTo.value).toString()
              );
              formData.append(
                "PlannedStartDate",
                moment(Startbydate).format(moment.HTML5_FMT.DATE)
              );
              formData.append(
                "PlannedEndDate",
                moment(Completebydate).format(moment.HTML5_FMT.DATE)
              );
              formData.append("HoursAssigned", Number(PlannedHours).toFixed(2));
              formData.append("HoursSpent", "0");
              formData.append(
                "TaskStatus",
                (EditStatus === "In Progress"
                  ? 3
                  : TaskStatus.NotStarted
                ).toString()
              );
              formData.append("IsChargeable", isChargable.toString());
              formData.append("CreatedBy", context.EmployeeId.toString());
              formData.append(
                "CreatedDate",
                moment(new Date()).format(moment.HTML5_FMT.DATE)
              );
              formData.append(
                "NoChargesReason",
                isChargable ? "" : Reason.label ? Reason.label : ""
              );
              formData.append("IsUnplanned", isPlanned.toString());
              formData.append("IsActive", isActive.toString());
              formData.append(
                "UnplannedReasons",
                isPlanned
                  ? ""
                  : selectedIsUnplannedReason.value?.toString() || ""
              );
              if (files) {
                Array.from(files).forEach((file, index) => {
                  formData.append("FileList", file); // Append each individual file
                });
              }
              

              const data = await APICalls(InsertUpdateTask, "POST", formData);
              let historyinsertobj = {
                Id: EditId == null ? data.data : data.data,
                TaskStatus:
                  EditStatus === "In Progress" ? 3 : TaskStatus.NotStarted,
                AssignedTo: context.EmployeeId,
                TaskUid: uuid(),
                TaskTitle: Task,
                TaskDescription: Description,
                //IsUnplanned :isUnplanned,
              };

              const { data1 } = await APICall(
                insertTaskHistory,
                "POST",
                historyinsertobj
              );

              hideLoader();

              if (data.message == "OK") {
                {
                  /*sangam*/
                }
                if (!isPlanned) {
                  await APICall(
                    mailForIsUnplannedPlannedTask,
                    "POST",
                    requestObject
                  );
                }
                navigate(`${env}/TaskDashboard`, { state: "true" });
                notify(0, "Task Saved Successfully");
              } else {
                notify(1, "Task Creation Failed");
              }
            }
          }

          //&&
          //isEngagementLead === false
          // &&
          // !RoleId.includes("3") &&
          // !RoleId.includes("8")

          // if (RoleId.includes("3") || RoleId.includes("8")) {

          //   if (isCapacityallocated === 0) {
          //     notify(
          //       1,
          //       "You're not allowed to create a Task for this Engagement. You need to be allocated  for this engagement "
          //     );
          //   }

          // } else if (RoleId.includes("2")) {
          //   if (isEngagementLead === false) {
          //     notify(
          //       1,
          //       "You're not allowed to create a Task for this Engagement. You need to be engagement lead for this engagement "
          //     );
          //   }
          // } else if (RoleId.includes("1")) {
          //   notify(
          //     1,
          //     "You're not allowed to create a Task for this Engagement.  "
          //   );
          // }
        } else {
          await checkValidations();

          const isEmpty = await Object.values(formErrorObj).every(
            (x) => x === null || x === "" || x == undefined
          );

          if (isEmpty) {
            showLoader();
            let requestObject = {};
            requestObject = {
              TaskUid: uuid(),
              Id: EditId,
              TaskTitle: Task,
              EngagementId: Engagement.engagementId,
              PhaseId: parseInt(Engagement.phasevalue),
              ApplicationId: parseInt(Engagement.applicationValue),
              RequirementId: Requirement.value, //Ankita
              TaskDescription: Description,
              AssignedTo: isAdhoc ? context.EmployeeId : AssignedTo.value,
              PlannedStartDate: moment(Startbydate).format(
                moment.HTML5_FMT.DATE
              ),
              PlannedEndDate: moment(Completebydate).format(
                moment.HTML5_FMT.DATE
              ),
              HoursAssigned: Number(PlannedHours).toFixed(2),
              HoursSpent: 0,
              TaskStatus:
                EditStatus === "In Progress" ? 3 : TaskStatus.NotStarted, //prashant 3 = in progress
              IsChargeable: isChargable,
              CreatedBy: context.EmployeeId,
              CreatedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
              NoChargesReason: isChargable
                ? ""
                : Reason.label
                ? Reason.label
                : "",
              IsUnplanned: isPlanned,
              IsActive: isActive,
              UnplannedReasons: isPlanned
                ? null
                : selectedIsUnplannedReason.value,
              //UnplannedReasons : selectedIsUnplannedReason.value? selectedIsUnplannedReason.value :null,
              // IsUnplannedReasonId:selectedIsUnplannedReason && selectedIsUnplannedReason.value,
            };

            //added by kausher

            // Create a new FormData object
            let formData1 = new FormData();

            formData1.append("TaskUid", uuid());
            const idValue = EditId ?? 0;
            formData1.append("Id", idValue.toString());
            formData1.append("TaskTitle", Task);
            formData1.append(
              "EngagementId",
              Engagement.engagementId ? Engagement.engagementId.toString() : "0"
            );
            formData1.append(
              "PhaseId",
              Engagement.phasevalue ? Engagement.phasevalue : ""
            );
            formData1.append(
              "ApplicationId",
              Engagement.applicationValue ? Engagement.applicationValue : ""
            );
            formData1.append(
              "RequirementId",
              Requirement.value ? Requirement.value.toString() : ""
            );
            formData1.append("TaskDescription", Description);
            formData1.append(
              "AssignedTo",
              (isAdhoc ? context.EmployeeId : AssignedTo.value).toString()
            );
            formData1.append(
              "PlannedStartDate",
              moment(Startbydate).format(moment.HTML5_FMT.DATE)
            );
            formData1.append(
              "PlannedEndDate",
              moment(Completebydate).format(moment.HTML5_FMT.DATE)
            );
            formData1.append("HoursAssigned", Number(PlannedHours).toFixed(2));
            formData1.append("HoursSpent", "0");
            formData1.append(
              "TaskStatus",
              (EditStatus === "In Progress"
                ? 3
                : TaskStatus.NotStarted
              ).toString()
            );
            formData1.append("IsChargeable", isChargable.toString());
            formData1.append("CreatedBy", context.EmployeeId.toString());
            formData1.append(
              "CreatedDate",
              moment(new Date()).format(moment.HTML5_FMT.DATE)
            );
            formData1.append(
              "NoChargesReason",
              isChargable ? "" : Reason.label ? Reason.label : ""
            );
            formData1.append("IsUnplanned", isPlanned.toString());
            formData1.append("IsActive", isActive.toString());
            formData1.append(
              "UnplannedReasons",
              isPlanned ? "" : selectedIsUnplannedReason.value?.toString() || ""
            );

            // If you have a file to upload, append it to the FormData object
            if (files) {
              Array.from(files).forEach((file, index) => {
                formData1.append("FileList", file); // Append each individual file
              });
            }

            
            // console.log(formData1);

            //ended by kausher
            const data = await APICalls(InsertUpdateTask, "POST", formData1);

            let historyinsertobj = {
              Id: EditId == null ? data.data : data.data,
              TaskStatus:
                EditStatus === "In Progress" ? 3 : TaskStatus.NotStarted,
              AssignedTo: context.EmployeeId,
              TaskUid: uuid(),
              TaskTitle: Task,
              TaskDescription: Description,
              //IsUnplanned :isUnplanned,
            };

            const { data1 } = await APICall(
              insertTaskHistory,
              "POST",
              historyinsertobj
            );

            hideLoader();

            if (data.message == "OK") {
              {
                /*sangam*/
              }
              if (!isPlanned) {
                await APICall(
                  mailForIsUnplannedPlannedTask,
                  "POST",
                  requestObject
                );
              }
              navigate(`${env}/TaskDashboard`, { state: "true" });
              notify(0, "Task Saved Successfully");
            } else {
              notify(1, "Task Creation Failed");
            }
          }
        }
      } else {
        await checkValidations();

        const isEmpty = await Object.values(formErrorObj).every(
          (x) => x === null || x === "" || x == undefined
        );

        if (isEmpty) {
          showLoader();
          let requestObject = {};
          requestObject = {
            TaskUid: uuid(),
            Id: EditId,
            TaskTitle: Task,
            EngagementId: Engagement.engagementId,
            PhaseId: parseInt(Engagement.phasevalue),
            ApplicationId: parseInt(Engagement.applicationValue),
            RequirementId: Requirement.value, //Ankita
            TaskDescription: Description,
            AssignedTo: isAdhoc ? context.EmployeeId : AssignedTo.value,
            PlannedStartDate: moment(Startbydate).format(moment.HTML5_FMT.DATE),
            PlannedEndDate: moment(Completebydate).format(
              moment.HTML5_FMT.DATE
            ),
            HoursAssigned: Number(PlannedHours).toFixed(2),
            HoursSpent: 0,
            TaskStatus:
              EditStatus === "In Progress" ? 3 : TaskStatus.NotStarted, //prashant 3 = in progress
            IsChargeable: isChargable,
            CreatedBy: context.EmployeeId,
            CreatedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            NoChargesReason: isChargable
              ? ""
              : Reason.label
              ? Reason.label
              : "",
            IsUnplanned: isPlanned,
            IsActive: isActive,
            UnplannedReasons: isPlanned
              ? null
              : selectedIsUnplannedReason.value,
            //UnplannedReasons : selectedIsUnplannedReason.value? selectedIsUnplannedReason.value :null,
            // IsUnplannedReasonId:selectedIsUnplannedReason && selectedIsUnplannedReason.value,
          };

          let formData2 = new FormData();

          formData2.append("TaskUid", uuid());
          const idValue = EditId ?? 0;
          formData2.append("Id", idValue.toString());
          formData2.append("TaskTitle", Task);
          formData2.append(
            "EngagementId",
            Engagement.engagementId ? Engagement.engagementId.toString() : "0"
          );
          formData2.append(
            "PhaseId",
            Engagement.phasevalue ? Engagement.phasevalue : ""
          );
          formData2.append(
            "ApplicationId",
            Engagement.applicationValue ? Engagement.applicationValue : ""
          );
          formData2.append(
            "RequirementId",
            Requirement.value ? Requirement.value.toString() : ""
          );
          formData2.append("TaskDescription", Description);
          formData2.append(
            "AssignedTo",
            (isAdhoc ? context.EmployeeId : AssignedTo.value).toString()
          );
          formData2.append(
            "PlannedStartDate",
            moment(Startbydate).format(moment.HTML5_FMT.DATE)
          );
          formData2.append(
            "PlannedEndDate",
            moment(Completebydate).format(moment.HTML5_FMT.DATE)
          );
          formData2.append("HoursAssigned", Number(PlannedHours).toFixed(2));
          formData2.append("HoursSpent", "0");
          formData2.append(
            "TaskStatus",
            (EditStatus === "In Progress"
              ? 3
              : TaskStatus.NotStarted
            ).toString()
          );
          formData2.append("IsChargeable", isChargable.toString());
          formData2.append("CreatedBy", context.EmployeeId.toString());
          formData2.append(
            "CreatedDate",
            moment(new Date()).format(moment.HTML5_FMT.DATE)
          );
          formData2.append(
            "NoChargesReason",
            isChargable ? "" : Reason.label ? Reason.label : ""
          );
          formData2.append("IsUnplanned", isPlanned.toString());
          formData2.append("IsActive", isActive.toString());
          formData2.append(
            "UnplannedReasons",
            isPlanned ? "" : selectedIsUnplannedReason.value?.toString() || ""
          );
          if (files) {
            Array.from(files).forEach((file, index) => {
              formData2.append("FileList", file); // Append each individual file
            });
          }

          

          const data = await APICalls(InsertUpdateTask, "POST", formData2);

          let historyinsertobj = {
            Id: EditId == null ? data.data : data.data,
            TaskStatus:
              EditStatus === "In Progress" ? 3 : TaskStatus.NotStarted,
            AssignedTo: context.EmployeeId,
            TaskUid: uuid(),
            TaskTitle: Task,
            TaskDescription: Description,
            //IsUnplanned :isUnplanned,
          };

          const { data1 } = await APICall(
            insertTaskHistory,
            "POST",
            historyinsertobj
          );

          hideLoader();

          if (data.message == "OK") {
            {
              /*sangam*/
            }
            if (!isPlanned) {
              await APICall(
                mailForIsUnplannedPlannedTask,
                "POST",
                requestObject
              );
            }
            navigate(`${env}/TaskDashboard`, { state: "true" });
            notify(0, "Task Saved Successfully");
          } else {
            notify(1, "Task Creation Failed");
          }
        }
      }
    } else {
      setFormErrors({});
      setEngagement({});
      setFromDate(null);
      setToDate(null);
      setRequirement("");
      setTask("");
      setDescription("");
      setAssignedTo({});
      setAssignedToOptions([]);
      setStartbydate(null);
      setCompletebydate(null);
      setPlannedHours("");
      setisChargable(false);
      setReason({});
      //setIsUnplannedReason({});
      setAllocatedMandays("");
      setAssignedMandays("");
      setBalancedMandays("");
      setAllocatedHours("");
      setAssignedHours("");

      setEstimatedHrs("");
      setEstimatedHrsWO("");
      setBalanceHrs("");
      setRequirementID("");
      setRequirement({});
      setRequirementOptions([]);
      setFiles([]);
      setFileNames([`No Attachments`]);
      
    }
    if (action === "Back") {
      // navigate(`${env}/TaskDashboard`);
      navigate(-1);
    }
  };

  const emptyRequirementDataOnEngagementChange = async () => {
    setEstimatedHrsWO("");
    setEstimatedHrs("");
    setBalanceHrs("");
    setRequirementID("");
    setAssignedTo({});
    setRequirement("");
    setAllocatedHours("");
    setAssignedHours("");
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    showLoader();
    if (apiFieldName === "Engagement") {
      // await onClickFunction('e', "Reset");

      // if (event.engagementType === 5 || event.engagementType === 2) {
      //below code is commented by mahesh on 22-10-2024 to show the internal proj also
      if (event.engagementType === 5) {
        setisChargable(false);
        // setDisabled(true);
      } else {
        setisChargable(true);
        // setDisabled(false);
      }
      // setisChargable(true);
      setDisabled(false);

      setEngagement(event);

      setEngagementType(event.engagementType);
      await assignedToApiCall(event.engagementId, event.assignedTo);
      await getBudgetMandays(event.engagementId, event.engagementType);

      await setFormErrors({
        ...formErrors,
        ["engagement_isEmpty"]: "",
        ["AssignedTo_isEmpty"]: "",
        ["Reason_isEmpty"]: "",
        ["Requirement_isEmpty"]: "",
        ["IsUnplannedReason_isEmpty"]: "",
        ["PlannedHours_isEmpty"]: "",
        ["TaskTitle_isEmpty"]: "",
        ["TaskDescription_isEmpty"]: "",
      });
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["engagement_isEmpty"]: "Select Engagement",
        });
      }

      emptyRequirementDataOnEngagementChange();
      var data = await CommonDropdownFunction(
        "assignedTo",
        event.engagementId,
        false
      );

      if (data != undefined || data != null) {
        let tempArray = [];
        await data.map((employee) => {
          let tempObj = {
            value: employee.id,
            label: employee.name,
          };
          tempArray.push(tempObj);
        });
        tempArray.sort((a, b) => a.label.localeCompare(b.label));
        setAssignedToOptions(tempArray);
        setDropDown1(true);
        setAssignedToOptionsLoaded(true);
      }

      //Reasons Dropdown
      var reason = await CommonDropdownFunction(
        "reason",
        event.engagementType,
        false
      );
      if (reason != undefined || reason != null) {
        let tempArray = [];
        await reason.map((reasons) => {
          let tempObj = {
            value: reasons.id,
            label: reasons.reason,
          };
          tempArray.push(tempObj);
        });
        setReasonOptions(tempArray);
        setDropDown1(true);
        setAssignedToOptionsLoaded(true);
      }
      //Requirement Title
      var requirementTitle = await getRequirementTitle(event.engagementId);
      //if ( requirementTitle.length > 0) {
      let tempArray = [];
      await requirementTitle.map((requirementTitle) => {
        let tempObj = {
          value: requirementTitle.id,
          label: requirementTitle.title,
        };
        tempArray.push(tempObj);
      });
      setRequirementOptions(tempArray);
      //setDisabled(true);
      //}
      // else{
      //   setDisabled(false);
      // }
    }
    hideLoader();
    if (apiFieldName === "AssignedTo" && !isAdhoc) {
      setAssignedTo(event);
      var postObj = {
        EngagementId: Engagement.engagementId,
        EmployeeId: event.value,
        fromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        toDate: moment(toDate).format(moment.HTML5_FMT.DATE),
      };

      var autoPopulateData = await APICall(
        getAutoPopulatedAssignedHoursData,
        "POST",
        postObj
      );
      if (autoPopulateData.data != undefined || autoPopulateData.data != null) {
        setAllocatedHours(
          autoPopulateData.data.hoursAllocated
            ? autoPopulateData.data.hoursAllocated * 8.5
            : 0
        );
        setAssignedHours(
          autoPopulateData.data.hoursAssigned
            ? autoPopulateData.data.hoursAssigned
            : 0
        );
      }
      await setFormErrors({
        ...formErrors,
        ["AssignedTo_isEmpty"]: "",
      });
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["AssignedTo_isEmpty"]: "Select Assigned To",
        });
      }
    }
    hideLoader();
    if (apiFieldName === "RequirementOpt") {
      setRequirement(event);
      var { data } = await getautoPopulateRequirementHrs(event.value);
      if (data != null || data != undefined) {
        setBalanceHrs(data.balance);
        setEstimatedHrs(data.estimate_Hours);
        setEstimatedHrsWO(data.estimat_Hours_w_o);
        setRequirementID(data.requirementID);
        setisChargable(data.isChargeable);
        //setDisabled(false);
        if (!data.isChargeable) {
          reasons = ReasonOptions.find(
            (res) => res.value === data.non_chargeable_Reason
          );
          setReason(reasons);
          await setFormErrors({
            ...formErrors,
            ["Reason_isEmpty"]: "",
          });
          if (
            data.nonchargeableReasonId === null ||
            data.nonchargeableReasonId === undefined ||
            data.nonchargeableReasonId === ""
          )
            await setFormErrors({
              ...formErrors,
              ["Reason_isEmpty"]: "Select Reason",
            });
        }
      } else {
        setBalanceHrs("");
        setEstimatedHrs("");
        setEstimatedHrsWO("");
        setRequirementID("");
      }
      await setFormErrors({
        ...formErrors,
        ["Requirement_isEmpty"]: "",
      });

      if (RequirementOptions.length > 0 || Engagement.engagementType == 3) {
        if (event == undefined || event == null || event == "") {
          await setFormErrors({
            ...formErrors,
            ["Requirement_isEmpty"]: "Select Requirement",
          });
        }
      } else {
        await setFormErrors({
          ...formErrors,
          ["Requirement_isEmpty"]: "",
        });
      }
    }
    hideLoader();
    if (apiFieldName === "Reason" && !isChargable) {
      setReason(event);
      await setFormErrors({
        ...formErrors,
        ["Reason_isEmpty"]: "",
      });
      //if (isChargable) {
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["Reason_isEmpty"]: "Select Reason",
        });
      }
      //}
    }
    hideLoader();
    //prashant
    if (apiFieldName === "Unplanned") {
      setSelectedIsUnplannedReason(event);
      await setFormErrors({
        ...formErrors,
        ["IsUnplannedReason_isEmpty"]: "",
      });
      if (event === null || event === undefined || event === "") {
        await setFormErrors({
          ...formErrors,
          ["IsUnplannedReason_isEmpty"]: "IsUnplannedReason cannot be empty",
        });
      }
    }
  };

  const onLoadAPI = async () => {
    showLoader();
    //check of adHoc or NOt
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    setFromDate(firstDay);
    setToDate(lastDay);

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const type = urlParams.get("type");
    if (type == "adhoc") {
      setIsAdHoc(true);
    } else {
      setIsAdHoc(false);
    }
    //Engagement Dropdown

    let EmployeeId = context.EmployeeId; //hardcoded
    var data;
    if (RoleId.includes("3") || RoleId.includes("8")) {
      var data = await CommonDropdownFunction(
        "engagementForManagerTask",
        EmployeeId,
        false
      );
    } else {
      var data = await CommonDropdownFunction("engagement", EmployeeId, false);
    }

    if (data != undefined || data != null) {
      let engagementArray = [];

      await data.map((engagement) => {
        let tempObj;
        if (engagement.phase != null) {
          tempObj = {
            phasevalue: engagement.phaseId,
            label: `${engagement.engagement}-${engagement.phase}`,
            value: uuid(),
            engagementId: engagement.engagementId,
            empId: engagement.employeeId,
            engagementType: engagement.engagementType,
          };
        } else if (engagement.application != null) {
          tempObj = {
            applicationValue: engagement.applicationId,
            label: ` ${engagement.engagement}-${engagement.application}`,
            value: uuid(),
            engagementId: engagement.engagementId,
            empId: engagement.employeeId,
            engagementType: engagement.engagementType,
          };
        } else {
          tempObj = {
            phasevalue: engagement.phaseId,
            label: `${engagement.engagement}`,
            value: uuid(),
            engagementId: engagement.engagementId,
            empId: engagement.employeeId,
            engagementType: engagement.engagementType,
          };
        }
        engagementArray.push(tempObj);
      });

      setEngagementOptions(engagementArray);
      setDropDown1(true);
    }
    hideLoader();
  };

  const CommonDropdownFunction = async (searchFor, searchValue, isTicket) => {
    showLoader();
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    let postObject = {
      searchFor: searchFor,
      searchValue: searchValue,
      fromDate: moment(firstDay).format(moment.HTML5_FMT.DATE),
      toDate: moment(lastDay).format(moment.HTML5_FMT.DATE),
      isTicket: isTicket,
    };
    showLoader();
    const { data } = await APICall(GetDropDownList, "POST", postObject);

    hideLoader();
    return data;
  };

  // Omkar P
  const handleIsActiveChange = () => {
    setIsActive(!isActive);
  };
  // Omkar P
  useEffect(() => {
    onLoadAPI();
  }, [location]);

  return (
    <>
      <Heading title={"Task Assignment"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement / Application / Phase <sup>*</sup>
              </label>
              <SelectForm
                options={EngagementOptions}
                placeholder="Select"
                //isDisabled={false}
                isDisabled={EditId ? true : false}
                value={Engagement}
                onChange={(event) => selectOnChange(event, "Engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
            <p style={{ color: "red" }}>{formErrors["engagement_isEmpty"]}</p>
          </div>

          {!isAdhoc ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>From date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="From date"
                      value={fromDate}
                      onChange={(e) => handleTextEvent(e, "fromDate")}
                      inputFormat="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                      PopperProps={{
                        disablePortal: true,
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, 8], // Keeps the calendar positioned 8px below the field
                            },
                          },
                          {
                            name: "preventOverflow",
                            options: {
                              enabled: true,
                              boundariesElement: "viewport", // Keeps the calendar within the viewport
                            },
                          },
                        ],
                      }}
                    />
                  </LocalizationProvider>
                </div>
                <p style={{ color: "red" }}>{formErrors["fromDate_isEmpty"]}</p>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>To date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="To date"
                      value={toDate}
                      onChange={(e) => handleTextEvent(e, "toDate")}
                      inputFormat="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                      PopperProps={{
                        disablePortal: true,
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, 8], // Keeps the calendar positioned 8px below the field
                            },
                          },
                          {
                            name: "preventOverflow",
                            options: {
                              enabled: true,
                              boundariesElement: "viewport", // Keeps the calendar within the viewport
                            },
                          },
                        ],
                      }}
                    />
                  </LocalizationProvider>
                </div>
                <p style={{ color: "red" }}>{formErrors["toDate_isEmpty"]}</p>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Allocated Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    className="numRight"
                    value={allocatedMandays}
                    onChange={(e) => handleTextEvent(e, "allocatedMandays")}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Assigned Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    className="numRight"
                    value={assignedMandays}
                    onChange={(e) => handleTextEvent(e, "assignedMandays")}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Balance Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    className="numRight"
                    value={balancedMandays}
                    onChange={(e) => handleTextEvent(e, "balancedMandays")}
                  />
                </div>
              </div>
            </>
          ) : null}

          {/* { commented by mahesh , to show requirements for all eng
            //Engagement.engagementType !== 1 && (
              // Engagement.engagementType === 3 &&
              //RequirementOptions.length > 0  */}

          {(RequirementOptions.length > 0 ||
            Engagement.engagementType == 3) && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Requirement <sup>*</sup>
                </label>
                <SelectForm
                  options={RequirementOptions}
                  placeholder="Select"
                  isDisabled={EditStatus === "In Progress" ? true : false}
                  value={Requirement}
                  onChange={(event) => selectOnChange(event, "RequirementOpt")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
                <p style={{ color: "red" }}>
                  {formErrors["Requirement_isEmpty"]}
                </p>
              </div>
            </div>
          )}

          {(RequirementOptions.length > 0 ||
            Engagement.engagementType == 3) && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>Requirement ID</label>
                <InputForm
                  placeholder={""}
                  isDisabled={true}
                  textArea={false}
                  className="numRight"
                  value={RequirementID}
                  onChange={(e) => handleTextEvent(e, "RequirementId")}
                />
              </div>
            </div>
          )}

          {(RequirementOptions.length > 0 ||
            Engagement.engagementType == 3) && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>Estimate Hrs Without Reuse</label>
                <InputForm
                  placeholder={""}
                  isDisabled={true}
                  textArea={false}
                  className="numRight"
                  value={EstimatedHrsWO}
                  onChange={(e) => handleTextEvent(e, "EstimateHrsWo")}
                />
              </div>
            </div>
          )}

          {(RequirementOptions.length > 0 ||
            Engagement.engagementType == 3) && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>Estimate Hrs With Reuse</label>
                <InputForm
                  placeholder={""}
                  isDisabled={true}
                  textArea={false}
                  className="numRight"
                  value={EstimatedHrs}
                  onChange={(e) => handleTextEvent(e, "EstimateHrs")}
                />
              </div>
            </div>
          )}

          {(RequirementOptions.length > 0 ||
            Engagement.engagementType == 3) && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>Balance Hrs</label>
                <InputForm
                  placeholder={""}
                  isDisabled={true}
                  textArea={false}
                  className="numRight"
                  value={BalanceHrs}
                  onChange={(e) => handleTextEvent(e, "BalanceHrs")}
                />
              </div>
            </div>
          )}

          {/* )
            } */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group clearfix">
              <label>Is Chargeable</label>
              <div>
                <label style={{ float: "left", marginRight: "5px" }}>No</label>
                <Form style={{ float: "left" }}>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label=""
                    onChange={(e) =>
                      handleCheckEvent(e.target.checked, "IsChargable")
                    }
                    checked={isChargable}
                    //   { ("Engagement"===2 || "Engagement"===5) ? (disabled={true}) : (disabled={false})}
                    disabled={disabled}
                  />
                </Form>
                <label style={{ float: "left" }}>Yes</label>
              </div>
            </div>
          </div>
          {!isChargable ? (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Reason, if not chargeable <sup>*</sup>
                </label>
                <SelectForm
                  options={ReasonOptions}
                  placeholder="Select"
                  isDisabled={EditStatus === "In Progress" ? true : false}
                  value={Reason}
                  onChange={(event) => selectOnChange(event, "Reason")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
              <p style={{ color: "red" }}>{formErrors["Reason_isEmpty"]}</p>
            </div>
          ) : null}
          {/* Prashant for isUnplanned */}
          {/* {EngagementType == 2 || EngagementType == 3 ? ( */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group clearfix">
              <label>Is UnPlanned</label>
              <div>
                <label
                  htmlFor="isPlanned-switch"
                  style={{ float: "left" }}
                  className="mr-2"
                >
                  Unplanned
                </label>
                <Form style={{ float: "left" }}>
                  <Form.Check
                    type="switch"
                    id="isPlanned-switch"
                    label=""
                    disabled={true}
                    // disabled={false}
                    // onChange={(e) => setIsPlanned(e.target.checked)}
                    onChange={(e) => setIsPlanned(e.target.checked)}
                    checked={isPlanned}
                  />
                </Form>
                <label
                  htmlFor="isPlanned-switch"
                  style={{ float: "left" }}
                  className="ml-2"
                >
                  Planned
                </label>
              </div>
            </div>
          </div>
          {!isPlanned ? (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Reason, if Is Unplanned <sup>*</sup>
                </label>
                <SelectForm
                  options={IsUnPlannedReason}
                  placeholder="Select"
                  isDisabled={EditStatus === "In Progress" ? true : false}
                  value={selectedIsUnplannedReason}
                  onChange={(event) => selectOnChange(event, "Unplanned")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
              <p style={{ color: "red" }}>
                {formErrors["IsUnplannedReason_isEmpty"]}
              </p>
            </div>
          ) : null}
          {/* ) : null} */}

          {/* {!isChargable ? (
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Reason, if not chargeable<sup>*</sup>
                  </label>
                  <SelectForm
                    options={ReasonOptions}
                    placeholder="Select"
                    isDisabled={false}
                    value={Reason}
                    onChange={(event) => selectOnChange(event, "Reason")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
                <p style={{ color: "red" }}>{formErrors["Reason_isEmpty"]}</p>
              </div>
              ) : null}                                          */}

          {/* Omkar P */}
          {/* isActive */}
          {EditId && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="dropdown25">Is Active</label>
                <div>
                  <input
                    type="checkbox"
                    id="dropdown25"
                    checked={isActive}
                    onChange={handleIsActiveChange}
                    disabled={EditId ? false : true}
                  />
                </div>
              </div>
            </div>
          )}
          {!isAdhoc ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Assigned To <sup>*</sup>
                  </label>
                  <SelectForm
                    key={1}
                    options={AssignedToOptions}
                    placeholder="Select"
                    isDisabled={EditStatus === "In Progress" ? true : false}
                    value={AssignedTo}
                    onChange={(event) => selectOnChange(event, "AssignedTo")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
                <p style={{ color: "red" }}>
                  {formErrors["AssignedTo_isEmpty"]}
                </p>
              </div>
            </>
          ) : null}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Start by date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Start by date"
                  value={Startbydate}
                  disabled={EditStatus === "In Progress" ? true : false}
                  onChange={(e) => handleTextEvent(e, "Startbydate")}
                  inputFormat="dd/MM/yyyy"
                  //  minDate={EditId&&Startbydate? Startbydate:new Date()} //prashant
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8], // Keeps the calendar positioned 8px below the field
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport", // Keeps the calendar within the viewport
                        },
                      },
                    ],
                  }}
                  minDate={isPlanned ? new Date() : undefined}
                  // disabled={isPlanned}
                />
              </LocalizationProvider>
            </div>
            <p style={{ color: "red" }}>{formErrors["Startbydate_isEmpty"]}</p>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Complete by date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Complete by date"
                  value={Completebydate}
                  onChange={(e) => handleTextEvent(e, "Completebydate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                  // minDate={Startbydate}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8], // Keeps the calendar positioned 8px below the field
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport", // Keeps the calendar within the viewport
                        },
                      },
                    ],
                  }}
                  minDate={isPlanned ? new Date() : Startbydate}
                />
              </LocalizationProvider>
            </div>
            <p style={{ color: "red" }}>
              {formErrors["Completebydate_isEmpty"]}
            </p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <Form.Label>
                Planned Hours <sup>*</sup>
              </Form.Label>
              <InputForm
                placeholder={""}
                className={"numRight"}
                isDisabled={false}
                textArea={false}
                value={PlannedHours}
                onChange={(e) => handleTextEvent(e, "PlannedHours")}
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
            <p style={{ color: "red" }}>{formErrors["PlannedHours_isEmpty"]}</p>
          </div>
          {!isAdhoc ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <Form.Label>Allocated Hours</Form.Label>
                  <InputForm
                    placeholder={""}
                    className={"numRight"}
                    isDisabled={true}
                    textArea={false}
                    value={allocatedHours}
                    onChange={(e) => handleTextEvent(e, "allocatedHours")}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <Form.Label>Assigned Hours</Form.Label>
                  <InputForm
                    placeholder={""}
                    className={"numRight"}
                    isDisabled={true}
                    textArea={false}
                    value={assignedHours}
                    onChange={(e) => handleTextEvent(e, "assignedHours")}
                  />
                </div>
              </div>
            </>
          ) : null}
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                Task Title <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={EditStatus === "In Progress" ? true : false}
                value={Task}
                rows={2}
                textArea={true}
                onChange={(e) => handleTextEvent(e, "TaskTitle")}
              />
            </div>
            <p style={{ color: "red" }}>{formErrors["TaskTitle_isEmpty"]}</p>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                Task Description <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={EditStatus === "In Progress" ? true : false}
                textArea={true}
                value={Description}
                rows={5}
                onChange={(e) => handleTextEvent(e, "TaskDescription")}
              />
            </div>
            <p style={{ color: "red" }}>
              {formErrors["TaskDescription_isEmpty"]}
            </p>
          </div>
          
         
            <div className="col-lg-12">
            <div className="d-flex gap-2">
              <div className="form-group">
                <label>
                 Attachments  
                </label>
                <div className="input-group">
                <input
                 multiple
                      type="file"
                      accept=".pdf, .doc, .docx, .png, .jpg, .jpeg, .xlsx, .pptx, .eml"
                      className="custom-file-input"
                      id="file"
                      aria-describedby="inputGroupFileAddon01"
                      style={{ borderRadius: "2px" }}
                      onChange={(e) => {
                        handleFiles(e, "Upload"); 
                      }}
                    />
                  <label
                    className="custom-file-label"
                    htmlFor="inputGroupFile01"
                  >
                    {FileNames || "Choose file..."}
                  </label>
                </div>
                <p style={{ color: "red" }}>
              {formErrors["AtMaxFiveFiles"]}
            </p>
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-reset"
                    onClick={() => {
                      setFileNames([`No attachments`]);
                      setFiles([]);
                      setFormErrors((prevState) => ({
                        ...prevState,
                        ["AtMaxFiveFiles"]: "",
                      }));
                      return;
                    }}
                  >
                    Clear
                  </button>
          
                </div>
              </div>
            </div>
          </div>



          <div className="col-lg-12">
            <div className="d-flex gap-2 justify-content-between">
              <div>
                <button
                  className="btn btn-reset"
                  onClick={(e) => onClickFunction(e, "Back")}
                >
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-reset"
                  onClick={(e) => onClickFunction(e, "Reset")}
                >
                  Reset
                </button>
                <button
                  className="btn btn-submit"
                  onClick={(e) => onClickFunction(e, "Submit")}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TaskAssignment;